import * as React from 'react';
/**
 *
 * Original name: person pause
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A344
 *
 */
export const PersonPausePictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M41 31h-1.044c1.45-2.41 2.16-5.19 2.044-8 0-7.514-3.738-12-10-12-6.262 0-10 4.486-10 12-.116 2.81.595 5.59 2.044 8H23a12.013 12.013 0 0 0-12 12v10h24v-4H15v-6a8.009 8.009 0 0 1 8-8h18a8.009 8.009 0 0 1 7.411 5h4.194A12.01 12.01 0 0 0 41 31Zm-15-8c0-5.309 2.019-8 6-8s6 2.691 6 8-2.019 8-6 8-6-2.691-6-8Z", fill: "currentColor" }),
    React.createElement("path", { d: "M43 44h-4v14h4V44Zm10 0h-4v14h4V44Z", fill: "currentColor" })));
